(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bh-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-bh-loc-autosubmit]');
    if (select && select.form) select.form.submit();
  });

  // Close the header dropdown on outside click or Escape.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-bh-loc-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-bh-loc-dropdown][open]').forEach((dropdown) => {
      dropdown.removeAttribute('open');
      dropdown.querySelector('summary')?.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
